export default {"src":"/_next/static/media/IQPizza.41e2768d.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};